/**
 * Browser polyfills for Node.js globals required by Solana libraries
 */
import { Buffer } from "buffer";

// Make Buffer available globally
window.Buffer = Buffer;
globalThis.Buffer = Buffer;

// Set up global object
window.global = window;
